import XButton from '../common/XButton';

const wrapperClasses = 'flex items-center justify-end gap-5';

const ReorderActions = ({ onCancel, onSave, className = '' }) => (
    <div className={`${wrapperClasses} ${className}`}>
        <XButton variant="outlinePrimary" onClick={onCancel}>Cancel</XButton>
        <XButton onClick={onSave}>Save</XButton>
    </div>
);

export default ReorderActions;
